//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/PlotSourceBuilder.js";
import "../no/CDF.js";
import "../no/PlotSourceBuilder.js";
import "../no/WidthDefinition.js";
let d=[[[0,"Action",1,0],[0,"AddWatermark",1,0],[0,"Append",1,0],[0,"Colors",1,0],[0,"CreateNewFromUi",1,0],[0,"CustomSymbolsInForeground",1,0],[0,"DatasetName",1,0],[0,"DatasetType",1,0],[0,"DeleteDatasets",1,0],[0,"Filename",1,0],[0,"ImageResolution",1,0],[0,"NamedReferenceType",1,0],[0,"OutputText",1,0],[0,"RasterImages",1,0],[0,"Relation",1,0],[0,"Scale",1,0],[0,"ShadedGeometry",1,0],[0,"Size",1,0],[1,"SourceBuilder",0,"PlotSourceBuilder",0],[0,"Units",1,0],[0,"UploadAsStandalone",1,0],[0,"Watermark",1,0],[0,"Widths",1,0],[0,"XDimension",1,0],[0,"YDimension",1,0]],[[[],"Assign",{},0,0],[[],"DefinePalette",{},0,0],[[],"DefineWidths",{},0,0],[[],"CreateCdf",{R_:{cdf:"CDF"}},0,0],[[],"GetCdf",{R_:{cdf:"CDF"}},0,0],[[],"CreateWidthDefinition",{R_:{widthDefinition:"WidthDefinition"}},0,0],[[],"GetWidthDefinition",{R_:{widthDefinition:"WidthDefinition"}},0,0]],[]];
SPLM.PrintPDFBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PrintPDFBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PrintPDFBuilder.Color = Object.freeze({
    "AsDisplayed" : "AsDisplayed", "PartColors" : "PartColors", "CustomPalette" : "CustomPalette", "BlackOnWhite" : "BlackOnWhite", "LegacyColors" : "LegacyColors", "ColorsByWidth" : "ColorsByWidth"});

SPLM.PrintPDFBuilder.Width = Object.freeze({
    "StandardWidths" : "StandardWidths", "SingleWidth" : "SingleWidth", "CustomThreeWidths" : "CustomThreeWidths", "CustomPalette" : "CustomPalette"});

SPLM.PrintPDFBuilder.SizeOption = Object.freeze({
    "FullScale" : "FullScale", "ScaleFactor" : "ScaleFactor", "Dimension" : "Dimension"});

SPLM.PrintPDFBuilder.UnitsOption = Object.freeze({
    "Metric" : "Metric", "English" : "English"});

SPLM.PrintPDFBuilder.ImageResolutionOption = Object.freeze({
    "Draft" : "Draft", "Low" : "Low", "Medium" : "Medium", "High" : "High"});

SPLM.PrintPDFBuilder.ActionOption = Object.freeze({
    "New" : "New", "Overwrite" : "Overwrite", "Append" : "Append", "Native" : "Native"});

SPLM.PrintPDFBuilder.OutputTextOption = Object.freeze({
    "Text" : "Text", "Polylines" : "Polylines"});

SPLM.PrintPDFBuilder.RelationOption = Object.freeze({
    "Specification" : "Specification", "Manifestation" : "Manifestation", "Undefined" : "Undefined"});

export default SPLM;